import StorageRepository from '../../Domain/Repositories/StorageRepository';
class LocalStorageRepository extends StorageRepository {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  set(key, value, expires) {
    window.localStorage.setItem(key, value);
  }
  get(key) {
    return window.localStorage.getItem(key) || undefined;
  }
  isExpired(key) {
    return !!window.localStorage.getItem(key);
  }
  remove(key) {
    window.localStorage.removeItem(key);
  }
}

export { LocalStorageRepository as default };